import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './theme.css';
import reportWebVitals from './reportWebVitals';

const THEME_KEY = 'ams_theme';
const isTheme = (value) => value === 'light' || value === 'dark';

function savedTheme() {
  const queryTheme = new URLSearchParams(window.location.search).get('theme');
  if (isTheme(queryTheme)) return queryTheme;
  const localTheme = window.localStorage?.getItem(THEME_KEY);
  if (isTheme(localTheme)) return localTheme;
  const cookieTheme = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${THEME_KEY}=`))
    ?.split('=')[1];
  return isTheme(cookieTheme) ? cookieTheme : 'dark';
}

function applyTheme(theme) {
  if (!isTheme(theme)) return;
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  window.localStorage?.setItem(THEME_KEY, theme);
}

applyTheme(savedTheme());
window.addEventListener('message', (event) => {
  if (event.data?.type === 'ams-theme') applyTheme(event.data.theme);
});
window.addEventListener('storage', (event) => {
  if (event.key === THEME_KEY) applyTheme(event.newValue);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
